__webpack_require__.p = "/delivery-list/";